import { createStart, createMiddleware } from "@tanstack/react-start";
import { getRequestUrl } from "@tanstack/react-start/server";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuthLazy } from "@/lib/supabase-auth-middleware";

const trace = (name: string) => (globalThis as { __rhMark?: (n: string) => void }).__rhMark?.(name);

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    trace("start.request");
    const result = await next();
    trace("start.response");
    return result;
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

const MARKETING_ROUTES = new Set([
  "/locations/restore-midwest",
  "/locations/restore-dallas",
  "/locations/restore-charlotte",
]);

const edgeCacheMiddleware = createMiddleware().server(async ({ next }) => {
  const result = await next();
  try {
    const url = new URL(getRequestUrl());
    const pathname = (url.pathname.replace(/\/$/, "") || "/");
    if (MARKETING_ROUTES.has(pathname)) {
      const response = (result as { response?: Response }).response;
      if (response && !response.headers.has("Cache-Control")) {
        response.headers.set(
          "Cache-Control",
          "public, max-age=0, must-revalidate, s-maxage=300, stale-while-revalidate=86400",
        );
        response.headers.set(
          "CDN-Cache-Control",
          "public, s-maxage=300, stale-while-revalidate=86400",
        );
      }
    }
  } catch {
    // best-effort
  }
  return result;
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthLazy],
  requestMiddleware: [errorMiddleware, edgeCacheMiddleware],
}));
